export { RecentlyGeneratedQuotesQueryWrapper } from './src/recently-generated-quotes-query-wrapper';
export { getRecentGeneratedQuotesWidgetContent } from './src/recently-generated-quotes-widget-content';
